import { render } from "./IndexBirthdateUpdate.vue?vue&type=template&id=3f43eae0"
import script from "./IndexBirthdateUpdate.vue?vue&type=script&lang=js"
export * from "./IndexBirthdateUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__